import React from "react";
import { ArrowRight, Phone } from "lucide-react";

const CTA = () => {
  return (
    <section className="hob-cta-section">
      <div className="hob-cta-container">
        <div className="hob-cta-left">
          <h2 className="hob-cta-heading">
            Ready to Experience Premium Service?
          </h2>
          <p className="hob-cta-description">
           Let us transport your loved ones to safety with our expert critical care services. Get a rapid, reliable, and life-saving response today!
          </p>
          <div className="hob-cta-button"
            onClick={() => (window.location.href = "tel:70390 34000")}
            style={{ cursor: "pointer" }}
          >
            <Phone size={18} /> Call Now
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
